"use client";

import React from "react";
import { GuideElement, type GuideElementProps } from "../BaseDemoElement";
import { Filter } from "lucide-react";
import { useIsMobile } from "@/hooks/use-breakpoint";
import { useResponsiveCardStyle, type CardSize } from "@/hooks/use-responsive-card-style";


interface ShowFiltersStepProps
  extends Omit<GuideElementProps, "title" | "description" | "icon" | "targetSelector"> {
  size?: CardSize;
}

export function ShowFiltersStep({ size = "md", ...rest }: ShowFiltersStepProps) {
  const cardStyle = useResponsiveCardStyle(size, "wide");
  const isMobile = useIsMobile();

  return (
    <GuideElement
      title="Use filters to refine results"
      description="Filter by platform, category, country, language and more to get precise matches."
      icon={Filter}
      targetSelector={isMobile ? undefined : '[data-guide-step="filters"]'}
      position={isMobile ? "center" : "right"}
      spotlight={true}
      forceSpotlight={!isMobile}
      offset={{ x: 12, y: 0 }}
      showArrow={false}
      disableAutoScroll={isMobile}
      computePosition={isMobile ? undefined : ({ getSpotlightBounds, defaultWidth, defaultHeight, margin }) => {
        const s = getSpotlightBounds();
        const ox = rest.offset && typeof rest.offset.x === 'number' ? rest.offset.x : 0;
        const oy = rest.offset && typeof rest.offset.y === 'number' ? rest.offset.y : 0;
        return {
          top: s.top + s.height / 2 - defaultHeight / 2 + oy,
          left: s.left + s.width + margin + ox,
          transform: 'none',
          tooltipWidth: defaultWidth,
          tooltipHeight: defaultHeight,
        };
      }}
      style={{ ...cardStyle, ...(rest.style || {}) }}
      {...rest}
    />
  );
}

export default ShowFiltersStep;

